package com.milta.core.localization.translations.pl

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Ładowanie…",
    errorNoConnection = "Nie można połączyć się z serwerem — sprawdź swoje połączenie.",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie później.",
    emptyStateMessage = "Brak danych.",
    kpiTotalDocumentsLabel = "Przeanalizowane dokumenty",
    kpiCompletedDocumentsLabel = "Kompletne dokumenty",
    kpiCompletedDocumentsSubtitle = "symulowane dla 4 strategii",
    kpiTotalRealCostLabel = "Całkowity rzeczywisty koszt",
    kpiTotalInputTokensLabel = "Tokeny wejściowe",
    kpiTotalOutputTokensLabel = "Tokeny wyjściowe",
    breakdownByFileKindLabel = "Podział",
    fileKindImageLabel = "Obrazy",
    fileKindPdfLabel = "PDF-y",
    fileKindXlsxLabel = "Arkusze kalkulacyjne",
    flowTitle = "Pełny przepływ, krok po kroku",
    flowYesLabel = "Tak",
    flowNoLabel = "Nie",
    flowStep1Title = "Dokument wysłany",
    flowStep1Subtitle = "Zdjęcie, PDF lub plik otrzymany przez aplikację",
    flowStep2Title = "Obliczono unikalny odcisk",
    flowStep2Subtitle = "Dla tego dokumentu obliczany jest unikalny identyfikator",
    flowStep2Note = "Jeśli już widziany: analiza lokalna nie jest powtarzana (rzeczywisty koszt AI jest nadal liczony normalnie, bo to prawdziwe przesłanie).",
    flowStep3Title = "Wykryto typ pliku",
    flowStep3Subtitle = "Dalsza analiza różni się w zależności od typu",
    flowImageBranchTitle = "📷 Jeśli to zdjęcie",
    flowImageStep1Title = "Kontrola jakości",
    flowImageStep1Subtitle = "Ostrość, jasność, rozdzielczość, dobrze skadrowany dokument",
    flowImageStep2Title = "Jeśli jakość zostanie uznana za niewystarczającą",
    flowImageStep2Subtitle = "Powód jest rejestrowany, ale lokalny odczyt jest mimo to podejmowany zaraz potem",
    flowImageStep3Title = "Korekta przekrzywienia",
    flowImageStep3Subtitle = "Obraz jest prostowany, jeśli wykryto wiarygodne przekrzywienie",
    flowImageStep4Title = "Odczyt lokalny (bezpłatny)",
    flowImageStep4Subtitle = "Odczyt tekstu bez AI — francuski, niderlandzki, angielski",
    flowImageStep5Title = "Wynik wiarygodności",
    flowImageStep5Subtitle = "Wynik od 0 do 100 dotyczący jakości tego lokalnego odczytu",
    flowPdfBranchTitle = "📄 Jeśli to PDF",
    flowPdfStep1Title = "Wykryto tekst natywny?",
    flowPdfStep1Subtitle = "Sprawdza, czy PDF już zawiera użyteczny tekst cyfrowy",
    flowPdfNote = "Jeśli zeskanowany bez tekstu natywnego: każda strona (maks. 20) jest renderowana do obrazu i ponownie odczytywana lokalnie, tak jak zdjęcie.",
    flowXlsxBranchTitle = "📊 Jeśli to arkusz kalkulacyjny",
    flowXlsxStep1Title = "Zidentyfikowano kolumny",
    flowXlsxStep1Subtitle = "Automatyczne lub wspomagane przez AI rozpoznawanie kolumn (nazwisko, adres, telefon…)",
    flowXlsxNote = "Struktura pliku (wiersze, kolumny, nagłówek) analizowana lokalnie.",
    flowClaudeTitle = "Wywołanie AI (Claude)",
    flowClaudeSubtitle = "Dziś zawsze wykonywane jest rzeczywiste wywołanie, niezależnie od powyższej ścieżki — naliczony rzeczywisty koszt",
    flowSimulationTitle = "🔬 Symulacja po fakcie (nie w produkcji)",
    flowSimulationNote = "Po zebraniu powyższych danych, 4 alternatywne strategie są odtwarzane na tych samych dokumentach, aby oszacować, ile kosztowałyby zamiast systematycznego wywołania AI — to dokładnie porównuje poniższa tabela. Żadna z tych 4 strategii nie jest obecnie faktycznie używana w produkcji.",
    flowPersistTitle = "Zapisano",
    flowPersistSubtitle = "Rzeczywisty wynik i 4 symulacje są przechowywane",
    flowDashboardTitle = "Panel",
    flowDashboardSubtitle = "Ten ekran agreguje wyniki według strategii",
    tableTitle = "Porównanie możliwych strategii",
    columnMode = "Strategia",
    columnDocuments = "Dokumenty",
    columnClaudeCalls = "Wywołania AI",
    columnProjectedCost = "Przewidywany koszt",
    columnRealCost = "Rzeczywisty koszt",
    columnSavings = "Przewidywane oszczędności",
    modeBaseline = "Obecna strategia",
    modeBaselineDescription = "AI jest wywoływane systematycznie dla każdego dokumentu — to jest rzeczywiście używane dziś w produkcji.",
    modeMinimal = "Lekkie wstępne przetwarzanie",
    modeMinimalDescription = "Drobne optymalizacje przed wysłaniem do AI, bez zmiany decyzji: AI jest zawsze wywoływane, ten sam koszt co obecna strategia.",
    modeTesseractGate = "Odczyt lokalny z awaryjnym AI",
    modeTesseractGateDescription = "Bezpłatny odczyt lokalny najpierw ocenia jakość dokumentu; AI jest wywoływane tylko wtedy, gdy ten odczyt zostanie uznany za niewystarczający.",
    modeTesseractOnly = "Tylko odczyt lokalny",
    modeTesseractOnlyDescription = "Brak jakiegokolwiek wywołania AI — tylko bezpłatny odczyt lokalny, potencjalnie mniej niezawodny przy dokumentach niskiej jakości.",
)
